import { createContext, Dispatch, SetStateAction } from "react";

export const DmeoContext = createContext<{
  metric: string;
  setMetric: Dispatch<SetStateAction<string>>;
  //@ts-ignore
}>({ metric: "" });
